import { createRouter, createWebHistory } from 'vue-router'
import ChartsofAccount from '../components/CoreUploads/UploadChartOfAccount.vue'
import CustomerAssumption from '../components/CoreUploads/UploadNewCustomerAssumption.vue'
import UploadCategory from '../components/CoreUploads/UploadCategory.vue'
import UploadSid from '../components/CoreUploads/UploadSID.vue'
import UploadServiceProduct from '../components/CoreUploads/UploadServiceProduct.vue'
import UploadUnitExpenditureBudget from '../components/CoreUploads/UploadUnitExpenditureBudget.vue'
import UploadRevenueProjection from '../components/CoreUploads/UploadRevenueProjection.vue'
import UploadUnitItem from '../components/CoreUploads/UploadUnitItem.vue'
import UploadCategoryAlias from '../components/CoreUploads/UploadCategoryAlias.vue'
import UploadItemDescription from '../components/CoreUploads/UploadItemDescription.vue'
import SetMprValues from '../components/CoreUploads/SetMprValues.vue'
import SetMprSaleValue from '../components/CoreUploads/SetMprSaleValue.vue'
import Settings from '../components/CoreUploads/SettingsPage.vue'
import HelloWorld from '../components/HelloWorld.vue'

const routes = [
    {
        path: '/',
        name: 'HelloWorld',
        component: HelloWorld
    },
  {
    path: '/chart-of-account',
    name: 'ChartsofAccount',
    component: ChartsofAccount
  },
  {
    path: '/customer-assumption',
    name: 'CustomerAssumption',
    component: CustomerAssumption
  },
  {
    path: '/upload-category',
    name: 'UploadCategory',
    component: UploadCategory
  },
  {
    path: '/upload-sid',
    name: 'UploadSid',
    component: UploadSid
  },
  {
    path: '/upload-service-product',
    name: 'UploadServiceProduct',
    component: UploadServiceProduct
  },
  {
    path: '/upload-unit-expenditure',
    name: 'UploadUnitExpenditureBudget',
    component: UploadUnitExpenditureBudget
  },
  {
    path: '/upload-revenue-projection',
    name: 'UploadRevenueProjection',
    component: UploadRevenueProjection
  },
  {
    path: '/upload-unit-item',
    name: 'UploadUnitItem',
    component: UploadUnitItem
  },
  {
    path: '/upload-category-alias',
    name: 'UploadCategoryAlias',
    component: UploadCategoryAlias
  },
  {
    path: '/upload-item-description',
    name: 'UploadItemDescription',
    component: UploadItemDescription
  },
  {
    path: '/mpr-finance',
    name: 'SetMprValues',
    component: SetMprValues
  },
  {
    path: '/mpr-new-sale',
    name: 'SetMprSaleValue',
    component: SetMprSaleValue
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
